import React from 'react';
import '../styles/ContactPage.css';
import '../styles/OurServices.css';
import { Link } from 'react-router-dom';
import Cal from "@calcom/embed-react";
import PageHeader from './PageHeader';
import ContactButton from './ContactButton';
import locIcon from '../assets/contact-Images/locIcon.svg';
import mailIcon from '../assets/contact-Images/mailIcon.svg';
import callIcon from '../assets/contact-Images/callIcon.svg';
import timeIcon from '../assets/contact-Images/timeIcon.svg';
import img from '../assets/contact-Images/img.png'

const ContactPage: React.FC = () => {
  const ArrowIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-page">

      <PageHeader heading="Let's Build Something Amazing Together" text="Have a project in mind? We'd love to discuss how we can help bring your vision to life."/>


      <div className="contact-page-content">
        <div className="contact-layout">
          {/* Calendar Area - Now Full Width at Top */}
          <div className="contact-interaction-area contact-full-width">
            <div className="contact-calendar-header">
              <p className='industries-section-title'>Book a 30-Minute Consultation</p>
              <p className="tech-section-subtitle">Schedule a call with our team to discuss your project requirements and how we can help bring your vision to life.</p>
            </div>

            {/* Cal.com React Component */}
            <div className="cal-embed-container">
              <Cal
                calLink="aditya-rl/30min"
                style={{ width: "100%", height: "100%", overflow: "hidden" }}
                config={{
                  theme: "dark", 
                  hideEventTypeDetails: "false",
                  hideBranding: "true"
                }}
              />
            </div>
          </div>

          {/* Contact Info Card - Now Below Calendar */}
          <div className="contact-info-card contact-full-width">           
            <div className="contact-calendar-header">
              <p className='industries-section-title'>We Would Love to Hear from You</p>
              <p className="tech-section-subtitle">Thank you for your interest in ReventLabs and our mission to help businesses thrive. We value your thoughts, questions, and feedback. Please don't hesitate to reach out to us. Our dedicated team is here to assist you.</p>
            </div>

            <div className="our-services-grid">
              <div className="our-services-card">
                <div className="our-services-icon">
                  <img src={locIcon} alt="Office location" />
                </div>

                <p className="our-service-description">
                  Address
                </p>
                <h3 className="our-service-title">Ashoka Garden, Opp. Praphat Pump, Bhopal, Madhya Pradesh 462023</h3>
                <Link to="/contact" className="our-service-link">
                  <ArrowIcon />
                </Link>
              </div>

              <div className="our-services-card">
                <div className="our-services-icon">
                  <img src={mailIcon} alt="Email" />
                </div>

                <p className="our-service-description">
                  Email Us
                </p>
                <h3 className="our-service-title">info@reventlabs.com</h3>
                <Link to="/contact" className="our-service-link">
                  <ArrowIcon />
                </Link>
              </div>

              <div className="our-services-card">
                <div className="our-services-icon">
                  <img src={callIcon} alt="Phone" />
                </div>

                <p className="our-service-description">
                  Call Us
                </p>
                <h3 className="our-service-title">+91 7024760509</h3>
                <Link to="/contact" className="our-service-link">
                  <ArrowIcon />
                </Link>
              </div>

              <div className="our-services-card">
                <div className="our-services-icon">
                  <img src={timeIcon} alt="Working hours" />
                </div>
                
                <p className="our-service-description">
                  Working Hours
                </p>
                <h3 className="our-service-title">10:00 am - 6:00 pm</h3>
                <Link to="/contact" className="our-service-link">
                  <ArrowIcon />
                </Link>
              </div>
            </div>
          </div>

          <div className='contact-connect-section'>
            <div className='contact-connect'>
              <div className='contact-connect-content'>
                <p className='content-title content-title-cc'>Benefits of ReventLabs</p>
                <p className='content-text content-text-cc'>At ReventLabs, our team is ready to help with your cloud, DevOps and security needs. Contact us today to discuss how we can support your business goals. We look forward to hearing from you.</p>
                <ContactButton variant="border" className="text-black">Connect with us</ContactButton>
              </div>
              <img src={img} alt='img'></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 